module.exports = __webpack_public_path__ + "img/who_solution_illustration.2e321c55.svg";